export interface EventSetupError {
  message: string;
  type: EventSetupErrorType
}


export enum EventSetupErrorType {
  generic,
  permissionDenied
}
